import {NgModule} from '@angular/core';
import {CustomSort} from './custom.sort';
import {CustomSortHeader} from './custom.sort.header';
import {GlobalModule} from '../../../core/global.module';

@NgModule({
    declarations: [
        CustomSort,
        CustomSortHeader
    ],
    imports: [
        GlobalModule
    ],
    exports: [
        CustomSort,
        CustomSortHeader
    ]
})
export class CustomSortModule {
}
